/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUserProfile = /* GraphQL */ `
  mutation CreateUserProfile(
    $input: CreateUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    createUserProfile(input: $input, condition: $condition) {
      id
      firstName
      lastName
      company
      company_orgNumber
      email
      phone
      validTo
      active
      LastLogin
      category
      subCategories
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateUserProfile = /* GraphQL */ `
  mutation UpdateUserProfile(
    $input: UpdateUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    updateUserProfile(input: $input, condition: $condition) {
      id
      firstName
      lastName
      company
      company_orgNumber
      email
      phone
      validTo
      active
      LastLogin
      category
      subCategories
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteUserProfile = /* GraphQL */ `
  mutation DeleteUserProfile(
    $input: DeleteUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    deleteUserProfile(input: $input, condition: $condition) {
      id
      firstName
      lastName
      company
      company_orgNumber
      email
      phone
      validTo
      active
      LastLogin
      category
      subCategories
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createJobRequest = /* GraphQL */ `
  mutation CreateJobRequest(
    $input: CreateJobRequestInput!
    $condition: ModelJobRequestConditionInput
  ) {
    createJobRequest(input: $input, condition: $condition) {
      id
      title
      startDate
      description
      location
      county
      municipality
      id06
      userId
      userMail
      category
      subCategories
      status
      startNow
      jobLength
      company
      createdAt
      jobType
      updatedAt
      jobRequestComments {
        nextToken
      }
    }
  }
`;
export const updateJobRequest = /* GraphQL */ `
  mutation UpdateJobRequest(
    $input: UpdateJobRequestInput!
    $condition: ModelJobRequestConditionInput
  ) {
    updateJobRequest(input: $input, condition: $condition) {
      id
      title
      startDate
      description
      location
      county
      municipality
      id06
      userId
      userMail
      category
      subCategories
      status
      startNow
      jobLength
      company
      createdAt
      jobType
      updatedAt
      jobRequestComments {
        nextToken
      }
    }
  }
`;
export const deleteJobRequest = /* GraphQL */ `
  mutation DeleteJobRequest(
    $input: DeleteJobRequestInput!
    $condition: ModelJobRequestConditionInput
  ) {
    deleteJobRequest(input: $input, condition: $condition) {
      id
      title
      startDate
      description
      location
      county
      municipality
      id06
      userId
      userMail
      category
      subCategories
      status
      startNow
      jobLength
      company
      createdAt
      jobType
      updatedAt
      jobRequestComments {
        nextToken
      }
    }
  }
`;
export const createJobRequestComment = /* GraphQL */ `
  mutation CreateJobRequestComment(
    $input: CreateJobRequestCommentInput!
    $condition: ModelJobRequestCommentConditionInput
  ) {
    createJobRequestComment(input: $input, condition: $condition) {
      id
      jobRequestId
      message
      userId
      userFirstName
      userLastName
      userEmail
      userPhone
      userCompany
      status
      createdAt
      updatedAt
      jobRequest {
        id
        title
        startDate
        description
        location
        county
        municipality
        id06
        userId
        userMail
        category
        subCategories
        status
        startNow
        jobLength
        company
        createdAt
        jobType
        updatedAt
      }
    }
  }
`;
export const updateJobRequestComment = /* GraphQL */ `
  mutation UpdateJobRequestComment(
    $input: UpdateJobRequestCommentInput!
    $condition: ModelJobRequestCommentConditionInput
  ) {
    updateJobRequestComment(input: $input, condition: $condition) {
      id
      jobRequestId
      message
      userId
      userFirstName
      userLastName
      userEmail
      userPhone
      userCompany
      status
      createdAt
      updatedAt
      jobRequest {
        id
        title
        startDate
        description
        location
        county
        municipality
        id06
        userId
        userMail
        category
        subCategories
        status
        startNow
        jobLength
        company
        createdAt
        jobType
        updatedAt
      }
    }
  }
`;
export const deleteJobRequestComment = /* GraphQL */ `
  mutation DeleteJobRequestComment(
    $input: DeleteJobRequestCommentInput!
    $condition: ModelJobRequestCommentConditionInput
  ) {
    deleteJobRequestComment(input: $input, condition: $condition) {
      id
      jobRequestId
      message
      userId
      userFirstName
      userLastName
      userEmail
      userPhone
      userCompany
      status
      createdAt
      updatedAt
      jobRequest {
        id
        title
        startDate
        description
        location
        county
        municipality
        id06
        userId
        userMail
        category
        subCategories
        status
        startNow
        jobLength
        company
        createdAt
        jobType
        updatedAt
      }
    }
  }
`;
export const createNotification = /* GraphQL */ `
  mutation CreateNotification(
    $input: CreateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    createNotification(input: $input, condition: $condition) {
      id
      userId
      category
      county
      municipality
      userEmail
      categoryName
      createdAt
      updatedAt
    }
  }
`;
export const updateNotification = /* GraphQL */ `
  mutation UpdateNotification(
    $input: UpdateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    updateNotification(input: $input, condition: $condition) {
      id
      userId
      category
      county
      municipality
      userEmail
      categoryName
      createdAt
      updatedAt
    }
  }
`;
export const deleteNotification = /* GraphQL */ `
  mutation DeleteNotification(
    $input: DeleteNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    deleteNotification(input: $input, condition: $condition) {
      id
      userId
      category
      county
      municipality
      userEmail
      categoryName
      createdAt
      updatedAt
    }
  }
`;
